import { render, staticRenderFns } from "./ViewHistorySection.vue?vue&type=template&id=7ddb732d&"
import script from "./ViewHistorySection.vue?vue&type=script&lang=ts&"
export * from "./ViewHistorySection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports